import {defineStore} from "pinia";
import axios from "axios";

export const useMapStore = defineStore({
    id: "projectsStore",
    state: () => ({
        isMapLoading: false,
        mapNewsList: [],
        mapFullNewsList: [],
        mapRatingList: [],
        test: null
    }),
    actions: {
        // Временно отключено: news/map/{id}/cards/* — старый API.
        // eslint-disable-next-line no-unused-vars
        async getMapNewsList(_projectId, _mapName, _date, _filters, _activeFilterTypeOption) {
            this.isMapLoading = false;
            this.mapNewsList = [];
            this.mapRatingList = [];
            return { mapNewsList: [], mapRatingList: [] };
        },

        // Временно отключено: News/cards/ids — старый API.
        // eslint-disable-next-line no-unused-vars
        async getMapFullNews(_idList) {
            this.isMapLoading = false;
            this.mapFullNewsList = [];
            return [];
        },

        async searchRegion(value) {
            try {
                const result = await axios.get(process.env.VUE_APP_BASE_API +  `MapFile/locations/${value}`);
                return result.data;
            } catch (e) {
                console.log(e);
                return [];
            }
        },

        /** Получение списка карт для проекта **/

        async getProjectMapFiles(projectId) {
            try {
                const response = await axios.get(process.env.VUE_APP_BASE_API + `MapFile/projects/${projectId}/maps`);
                return response.data;
            }  catch (e) {
                console.log(e);
            }

            return [];
        },

        /** Удаление существующий карты **/
        async deleteMap(projectId, mapName) {
          try {
              const response = await axios.delete(process.env.VUE_APP_BASE_API + `MapFile/projects/${projectId}/maps/${mapName}`);
              return response.data;
          } catch (error) {
              console.log(error);
              throw error;
          }
        },

        /** Создание новой карты из списка существующих. **/
        async createMap(projectId, locationId, mapName) {
            try {
                const response = await axios.post(
                  process.env.VUE_APP_BASE_API + `MapFile/projects/${projectId}/maps/${locationId}`,
                  { mapName: mapName.trim() },
                  { timeout: 300000 } // 5 минут
                );
                return response.data;
            } catch (error) {
                console.log(error);
                throw error;
            }
        },

        /** Загрузка собственной карты в формате geojson **/
        async uploadMap(projectId, file) {
            try {
                const formData = new FormData();
                formData.append("formFile", file);
                formData.append("MapName", file.name);

                const response = await axios.post(
                  process.env.VUE_APP_BASE_API + `MapFile/projects/${projectId}/maps/upload`,
                  formData
                );

                return response.data;
            } catch (error) {
                console.error("Ошибка загрузки GeoJSON файла:", error);
                throw error;
            }
        }
    }
});
